import React, { Fragment, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { operdoneEditSchema } from '../../constant-value/schema';
import {  OPERDONE_UPDATE } from '../../constant-value';
import styles from "./edit-operdon.module.css";
import { toast } from 'react-toastify';
import api from '../../services/axiosConfig';
import DatePicker from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import { useEffect } from 'react';
import { toEnglishDigits } from '../../services/functions';
import { SiSpeedtest } from 'react-icons/si';
import { FaRegCalendarAlt } from 'react-icons/fa';
import ServiceIcon from '../operate/card-two-side/service-icon';



const EditOperdon = () => {
  const [date, setDate] = useState(null);
    const { state } = useLocation();
    const navigate = useNavigate();

    const beforeHandler = () => {
        navigate(-1);
    };

    const [operdone, setOperdone] = useState({
        operdonId: state.id,
        carId: 'state.car_Id',
        operKindId: state.ok_id,
        operDonKM: state.operDonKM4Edit,
        cost: state.cost4Edit,
        description: state.description,
        operDonDate: new Date(state.operDonDate),
        operateId: '-1',
        opTitle: state.opTitle
    });
    
    const numberChangeHandler = (evt) => {
        const value = evt.target.value === '' ? '' : parseFloat(evt.target.value);
        setFieldValue(evt.target.id, value);
    }
    const stringChangeHandler = (evt) => {
        setFieldValue(evt.target.id, evt.target.value);
    }

    const message = (message,type) => {
      if (type==='warn') {
        toast.warning(message, {
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success(message, {
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }

    const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue, // 👈 اینو اضافه کن
    } = useFormik({
        enableReinitialize: true,
        initialValues: operdone,
        validationSchema: operdoneEditSchema,    
        onSubmit: (values) => {
          
          let payload = {...values};
          if (date){
            const gregorianDate = toEnglishDigits(
              date.convert(gregorian, "en").format("YYYY-MM-DD HH:mm:ss")
            );
            payload = {
              ...values,
              operDonDate: gregorianDate
            };
          }


          api.put(`/${OPERDONE_UPDATE}/${state.id}`, payload)
              .then((res) => {
                if (res.data.isSuccess) {
                    message(res.data.message,'success');
                } else {
                    message(res.data.message,'warn');
                }
                navigate("/");
            });


            // axios.put(`${BASE_URL}/${OPERDONE_UPDATE}/${state.id}`, values).then((res) => {
            //     if (res.data.isSuccess) {
            //         message(res.data.message,'success');
            //     } else {
            //         message(res.data.message,'warn');
            //     }
            //     navigate("/");
            // });
        },
    });

    useEffect(() => {
      if (!date) return;
      setOperdone({
        ...operdone,
        operDonDate: date,
      })
    }, [date]);



  return (
<Fragment>
  <div className="container py-4">
    {/* کارت اصلی فرم ویرایش سابقه */}
    <div className="card mb-4 shadow-sm rounded-4" style={{ fontSize: "0.9rem" }}>
      {/* هدر کارت */}
      <div className="card-header bg-light py-3 px-4 rounded-top-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <ServiceIcon categoryId={state.ok_id} size={24} className="me-3" />
            <div>
              <span className="fw-bold d-block">{state.opTitle}</span>
              <small className="text-muted">{state.car_title}</small>
            </div>
          </div>
          <div className="text-primary">
            {state.ok_serviceType === "km" ? (
              <SiSpeedtest size={22} />
            ) : (
              <FaRegCalendarAlt size={22} />
            )}
          </div>
        </div>
      </div>

      {/* بدنه کارت */}
      <div className="card-body p-4">
        <form onSubmit={handleSubmit} noValidate>
          <input value={values.carId} id="carId" type="hidden" readOnly />
          <input value={values.operKindId} id="operKindId" type="hidden" readOnly />

          <div className="row g-3 mb-4">
            {/* کیلومتر سرویس */}
            <div className="col-12 col-md-6">
              <label htmlFor="operDonKM" className="form-label fw-semibold small mb-2">
                کیلومتر سرویس خودرو
              </label>
              <input
                value={values.operDonKM}
                onChange={numberChangeHandler}
                id="operDonKM"
                type="text"
                inputMode="numeric"
                onBlur={handleBlur}
                className={`form-control rounded-3 ${
                  errors.operDonKM && touched.operDonKM ? "is-invalid" : ""
                }`}
              />
              {errors.operDonKM && touched.operDonKM && (
                <div className="invalid-feedback small">{errors.operDonKM}</div>
              )}
            </div>

            {/* هزینه سرویس */}
            <div className="col-12 col-md-6">
              <label htmlFor="cost" className="form-label fw-semibold small mb-2">
                هزینه سرویس
              </label>
              <input
                value={values.cost}
                onChange={numberChangeHandler}
                id="cost"
                type="text"
                inputMode="numeric"
                onBlur={handleBlur}
                className={`form-control rounded-3 ${
                  errors.cost && touched.cost ? "is-invalid" : ""
                }`}
              />
              {errors.cost && touched.cost && (
                <div className="invalid-feedback small">{errors.cost}</div>
              )}
            </div>

            {/* توضیحات */}
            <div className="col-12">
              <label htmlFor="description" className="form-label fw-semibold small mb-2">
                توضیحات
              </label>
              <textarea
                value={values.description}
                onChange={stringChangeHandler}
                id="description"
                rows="3"
                onBlur={handleBlur}
                className={`form-control rounded-3 ${
                  errors.description && touched.description ? "is-invalid" : ""
                }`}
              />
              {errors.description && touched.description && (
                <div className="invalid-feedback small">{errors.description}</div>
              )}
            </div>

            {/* تاریخ انجام */}
            <div className="col-12 col-md-6">
              <label htmlFor="OperDonDate" className="form-label fw-semibold small mb-2">
                تاریخ انجام
              </label>
              <div className="border rounded-3 p-2 bg-white">
                <DatePicker
                  inputClass={`form-control ${
                    errors.operDonDate && touched.operDonDate ? "is-invalid" : ""
                  }`}
                  calendar={persian}
                  locale={persian_fa}
                  value={values.operDonDate || ""}
                  onChange={setDate}
                  format="YYYY/MM/DD"
                  calendarPosition="bottom-right"
                />
              </div>
              {errors.operDonDate && touched.operDonDate && (
                <div className="invalid-feedback d-block small">
                  {errors.operDonDate}
                </div>
              )}
            </div>
          </div>

          {/* دکمه‌ها */}
          <div className="d-flex justify-content-between gap-3">
            <button
              type="button"
              onClick={beforeHandler}
              className="btn btn-outline-secondary btn-sm flex-grow-1"
            >
              قبلی
            </button>
            <button
              type="submit"
              className="btn btn-success btn-sm flex-grow-1"
              disabled={isSubmitting}
            >
              {isSubmitting ? "در حال ذخیره..." : "تایید و ذخیره"}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</Fragment>

  );
};

export default EditOperdon;